import React, { useState } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Snackbar,
    Typography,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import { QRCodeSVG } from 'qrcode.react';

interface Props {
    open: boolean;
    onClose: () => void;
    personId: number;
    personName?: string;
}

const QRCodeScanDialog = (props: Props) => {
    const [copied, setCopied] = useState(false);

    const token = localStorage.getItem('token-id') || '';
    const url = `${window.location.origin}/mobile-scan/${props.personId}?token=${encodeURIComponent(token)}`;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
        } catch {
            // Fallback for older browsers
            const textarea = document.createElement('textarea');
            textarea.value = url;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            setCopied(true);
        }
    };

    return (
        <Dialog open={props.open} onClose={props.onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                Digitalizar por Celular
                <IconButton size="small" onClick={props.onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, pt: 1 }}>
                {props.personName && (
                    <Typography variant="subtitle2" color="text.secondary">
                        Aluno: <strong>{props.personName}</strong>
                    </Typography>
                )}

                <Box sx={{
                    p: 2,
                    bgcolor: '#fff',
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                }}>
                    <QRCodeSVG value={url} size={256} level="M" />
                </Box>

                <Typography variant="body2" color="text.secondary" textAlign="center">
                    Escaneie o QR code com seu celular para abrir a tela de digitalização de documentos.
                </Typography>
            </DialogContent>

            <DialogActions sx={{ px: 2, pb: 2, justifyContent: 'center' }}>
                <Button
                    variant="outlined"
                    startIcon={<ContentCopyIcon />}
                    onClick={handleCopy}
                    size="small"
                >
                    Copiar Link
                </Button>
                <Button variant="contained" onClick={props.onClose} size="small">
                    Fechar
                </Button>
            </DialogActions>

            <Snackbar
                open={copied}
                autoHideDuration={2000}
                onClose={() => setCopied(false)}
                message="Link copiado!"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            />
        </Dialog>
    );
};

export default QRCodeScanDialog;
